/**
 * Supported date string formats for transformers
 */
export type PrizmDateStringType = 'UTC' | 'ISO';
